// store.js
import { legacy_createStore as createStore,combineReducers, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // for localStorage
import reduxSaga from 'redux-saga';
import rootSaga from './sagas';
import reducers from './reducers'; // your reducers as an object

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['authReducer'], // only persist this reducer
};

const rootReducer = combineReducers({
  ...reducers,
});
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = reduxSaga();

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);
